import React from "react"

import FinderTaskModel from "../../../../model2/task/finder/finder-task-model"

// @ts-ignore
import TaskIcon from "../../../../../core/gd-components/icons/task-icon/task-icon"

type Props = {
    task                : FinderTaskModel

    isHighlighted       : boolean
    showParentProject   : boolean
    selected            : boolean
    noSubtasks?         : boolean

    onClickTask?        : func
}

type State = {
    expanded: boolean
}

const debug = false
// const debug = "FinderTask"

export default class FinderTask extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
            expanded: false
        }
    }

    click = () => {
        this.onClickTask(this.props.task)
    }

    onClickTask = (task: FinderTaskModel, e?: any) => {
        if (e) e.stopPropagation()
        if (this.props.onClickTask) this.props.onClickTask(task)
    }

    onToggleExpand = (e: any) => {
        e.stopPropagation();
        this.setState({
            expanded: !this.state.expanded
        })
    }

    renderSingle(task: FinderTaskModel, showParentProject: boolean) {
        const classes = Classes("search-item task", {
            'is-highlighted': this.props.isHighlighted,
            selected        : this.props.selected
        })

        debug && console.log(debug, 'renderSingle', task)

        return (
            <div key        = {task.id}
                 className  = {classes}
                 onClick    = {(e)=>this.onClickTask(task, e)}>
                <TaskIcon className="search-item-icon task-icon" icon={task.icon}/>
                <div className="search-item-details">
                    <div className="search-item-title">
                        <div className="search-item-title-label">{task.title}</div>
                        {showParentProject &&
                            <div className="search-item-project"><div className="project-label">{task.project?.name}</div></div>}
                    </div>
                    <div className="search-item-short-id">#{task.shortId}</div>
                </div>
            </div>
        )
    }

    renderWithSubtasks(task: FinderTaskModel, showParentProject: boolean) {
        const expandClasses = Classes("search-item-expand-icon", {
            "i5-big-angle-right"   : !this.state.expanded,
            "i5-big-angle-down"    : this.state.expanded,
        })

        return (
            <div className="search-item-container">
                <div className={expandClasses} onClick={this.onToggleExpand}/>
                {this.renderSingle(task, showParentProject)}

                {this.state.expanded &&
                    <div className="subtasks-container">
                        {_.map(task.subtasks, (subtask: FinderTaskModel)=>
                            this.renderSingle(subtask, showParentProject))}
                    </div>}
            </div>
        )
    }

    render() {
        return !this.props.noSubtasks && this.props.task.subtasks ?
            this.renderWithSubtasks(this.props.task, this.props.showParentProject) :
            this.renderSingle(this.props.task, this.props.showParentProject)
    }
}